import deepEqual from 'fast-deep-equal';
import { LayoutSession } from '@jbrowse/core/pluggableElementTypes/renderers/BoxRendererType';
import { readConfObject } from '@jbrowse/core/configuration';
// Sorting and revealing soft clip changes the layout of Pileup renderer
// Adds extra conditions to see if cached layout is valid
export class PileupLayoutSession extends LayoutSession {
    constructor(args) {
        super(args);
        this.showSoftClip = false;
        this.config = args.config;
    }
    cachedLayoutIsValid(cachedLayout) {
        return (super.cachedLayoutIsValid(cachedLayout) &&
            this.showSoftClip === cachedLayout.showSoftClip &&
            deepEqual(this.sortedBy, cachedLayout.sortedBy) &&
            deepEqual(this.filterBy, cachedLayout.filterBy));
    }
    get layout() {
        if (!this.cachedLayout || !this.cachedLayoutIsValid(this.cachedLayout)) {
            this.cachedLayout = {
                layout: this.makeLayout(),
                config: readConfObject(this.config),
                filters: this.filters,
                filterBy: this.filterBy,
                sortedBy: this.sortedBy,
                showSoftClip: this.showSoftClip,
            };
        }
        return this.cachedLayout.layout;
    }
}
